import { environment } from 'environments/environment';
import { DossierNavigationService } from './dossier-navigation.service';
import { StoreService } from 'app/ngrx/store.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject, tap, switchMap } from 'rxjs';
import { Navigation } from 'app/core/navigation/navigation.types';

@Injectable({
    providedIn: 'root'
})
export class NavigationService {
    private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);
    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient, private readonly dossiers: DossierNavigationService, private readonly storeService: StoreService) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation> {
        return this._navigation.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    get(): Observable<Navigation> {
        return this.dossiers.refresh(this.storeService.getConnectedUser()).pipe(
            switchMap(() => this._httpClient.get<Navigation>(
                environment.apiCatalog.common.controllerRoute + environment.apiCatalog.common.subRoutes.navigation
            )),
            tap((navigation) => {
                this._navigation.next(navigation);
            })
        );
    }
}
